import PicPostRequest from '../PicPostRequest';
import { prtErr } from '../../utils/prt';

/* Note, the payload itself has the parms need to make the api call  */
const addNewParticipant = (event_id, organizerEmail, participantEmail, participantName, addToContacts) => {

    let reqObject = {
        event_id,
        organizerEmail,
        email: participantEmail,
        name:  participantName,
        addToContacts
    }

    let apiPromise  = new Promise (function resolver(resolve, reject) {   
            /* make api call */
            let postParticipantRequest  = new PicPostRequest("postParticipantRequest");
            postParticipantRequest
                .setUserId(participantEmail)
                .setUri("/event/participant")
                .setRequestBody(reqObject)
                // .setAuthToken(token)  /* set token for internal request */
                .setLogTrace(true);
                postParticipantRequest.exec().then((response) => {
                if (!response) {console.log(`No response => /${response}/`)}
                console.log("Response data is ", JSON.stringify(response.data,null,2))
                resolve(response);
            }).catch(() => {
                let error = postParticipantRequest.getError(); /* print notification below but propagate actual via reject for debugging purposes */
                prtErr(`Error: encountered with the addNewParticipant api while trying to add participant:${participantEmail} for event_id:${event_id} `);
                reject(error)
            })
    }); /* end Promise */
    return apiPromise;
}

export default addNewParticipant;





// WEBPACK FOOTER //
// ./src/apis/participant/addNewParticipant.js